import api from './api';
import { DadosMetricasPCM } from '../interfaces/metricas';

export const metricas = {
    enviarEventoPreLogin: (payload: DadosMetricasPCM) => {
        return api.post(
            "/openfinance/aspsp/v1/pcm/preauth",
            payload
        );
    },

    enviarEventoPosLogin: (payload: Omit<DadosMetricasPCM, "type" >) => {
        return api.post(
            "/openfinance/aspsp/v1/pcm/auth",
            payload
        );
    },
};